import { useNavigate } from 'react-router-dom';
import type { SearchGroup, EntityType } from '@/api/search';
import { ENTITY_META, SEE_ALL_URL } from './entityMeta';
import { ResultRow } from './ResultRow';

export interface ResultGroupProps {
  type: EntityType;
  group: SearchGroup;
  query: string;
  showCustomer: boolean;
}

export function ResultGroup({ type, group, query, showCustomer }: ResultGroupProps) {
  const navigate = useNavigate();
  const meta = ENTITY_META[type];
  const Icon = meta.icon;

  if (group.total === 0) {
    return (
      <div className="flex items-center justify-between border-b border-slate-100 px-3 py-1.5 text-xs text-slate-400">
        <span className="flex items-center gap-1.5">
          <Icon className="h-3.5 w-3.5" />
          <span className="font-semibold uppercase tracking-wide">{meta.label}</span>
          <span>· 0 matches</span>
        </span>
      </div>
    );
  }

  return (
    <div className="border-b border-slate-100 last:border-b-0">
      <div className="flex items-center justify-between px-3 pt-2 pb-1">
        <span className="flex items-center gap-1.5 text-xs text-slate-500">
          <Icon className="h-3.5 w-3.5" />
          <span className="font-semibold uppercase tracking-wide text-slate-700">{meta.label}</span>
          <span>· {group.total} {group.total === 1 ? 'match' : 'matches'}</span>
        </span>
        {group.total > group.rows.length && (
          <button
            type="button"
            onClick={() => navigate(SEE_ALL_URL[type](query))}
            className="text-xs text-blue-600 hover:underline"
          >
            See all {group.total} →
          </button>
        )}
      </div>
      <div className="pb-1">
        {group.rows.map((row) => (
          <ResultRow key={`${type}:${row.id}`} row={row} showCustomer={showCustomer} />
        ))}
      </div>
    </div>
  );
}
